const __WEBPACK_NAMESPACE_OBJECT__ = require("@patsnap-biz/user-center");